import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import store from '../../admin/store'
import SnIcon from '../../front/components/shared/sn-icon'

const welcomingBannerImageSrc = '/images/welcoming-modal.png'

const benefitsListText = [
    'welcomingModal.benefitsList.offers',
    'welcomingModal.benefitsList.community',
    'welcomingModal.benefitsList.roles',
    'welcomingModal.benefitsList.free',
]

const CloseButton = styled.button`
    position: absolute;
    top: 5px;
    right: 10px;
    background: transparent;
`

const WelcomingModal = () => {
    const { t } = useTranslation()

    return (
        <div className="d-flex flex-column justify-content-center border-bottom position-relative">
            <CloseButton
                onClick={() => store.dispatch({ type: 'TOGGLE_LOGIN_MODAL' })}
                className="font-size-md border-0 text-color-grey-dark-1"
            >
                &times;
            </CloseButton>
            <img
                className="img-fluid"
                src={welcomingBannerImageSrc}
                alt="Banner Image"
            />
            <div className="px-sm-0 px-md-5 pt-3">
                <h1 className="text-center">
                    {t('welcomingModal.title')}
                </h1>
                <p className="text-center">
                    {t('welcomingModal.subTitle')}
                </p>
                <ul className="unstyled mt-3 mb-3">
                    {benefitsListText.map((benefit, index) =>
                        <li key={index} className="d-flex align-items-center">
                            <SnIcon className="sn-confirm text-color-brand mr-2" />
                            {t(benefit)}
                        </li>
                    )}
                </ul>
            </div>
        </div>
    )
}
export default WelcomingModal
